module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 14.27.32.7b94323b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 14.27.32.png
// module id = 1244
// module chunks = 1